import { isCapitalSupportedCountry } from '@hapana/shared/constants/capital.constants'

import { STRIPE_GATEWAY_TYPE } from './capital.constants'

import type { SiteGatewayForCapital } from '_services/capital.service'

interface CapitalAvailabilityInput {
  isFlagEnabled: boolean
  hasCapitalPermission: boolean
  siteId?: string | null
  gateway?: SiteGatewayForCapital | null
}

/**
 * Whether Capital is offered to this location — gates both the left-nav item and the page.
 *
 * Everything has to line up: the flag is on, the staff user holds the Capital permission, a
 * location is selected, that location bills through Stripe with a publishable key — Connect's
 * embedded components exist only on Stripe, so an Ezypay location has nothing to mount — and it
 * sits in a country the programme has launched in.
 *
 * A brand that does not want Capital grants `access__capital` to nobody, which hides it across the
 * network and is reversible at any time from Team Access.
 */
export const isCapitalAvailable = ({
  isFlagEnabled,
  hasCapitalPermission,
  siteId,
  gateway,
}: CapitalAvailabilityInput): boolean =>
  Boolean(
    isFlagEnabled &&
    hasCapitalPermission &&
    siteId &&
    gateway?.paymentGatewayType === STRIPE_GATEWAY_TYPE &&
    gateway?.paymentGatewayPublishableKey &&
    isCapitalSupportedCountry(gateway?.countryCode)
  )
